/*global $ */
import {create} from '../lib/instances'
import {observeResize} from '../lib/utils'
import renderFunZoneRewardsMenu from './funzone-rewards-menu'

const parentClass = 'addiesaas-mini-components'
const parentContainerClass = 'addiesaas-mini-components-container'

const onLoyaltyStatusResize = (instance) => {
  const parent = $(instance.$el).parent()
  const isMobile = parent.hasClass('mobile-view')
  const height = isMobile ? (parent.height() || 0) : 0
  $('.page-main').css({'margin-top': height + 'px'})
}

const miniItems = [
  {
    component: 're-login-status',
    componentOptions: {
      component: {
        attributes: {
          profileLabel: '',
          signOutLabel: '',
          signInLabel: '',
          showProfileInProfile: true,
          noSignOutLink: true,
          showProfileMenu: false,
        }
      }
    },
    rendered(instance) {
      renderFunZoneRewardsMenu(instance)
    },
    target: {
      targetSelector: '.page-header-full nav .container > ol',
      root: `li.${parentClass}.component-re-login-status`,
      element: `<li class="${parentClass} component-re-login-status"></li>`,
      method: 'appendTo',
    }
  },
  {
    component: 're-login-status',
    componentOptions: {
      component: {
        attributes: {
          profileLabel: '',
          signOutLabel: '',
          signInLabel: '',
          showProfileInProfile: false,
          noSignOutLink: false,
          showProfileMenu: false,
        }
      }
    },
    target: {
      targetSelector: '.nav-compact-buttons',
      container: `.${parentContainerClass}`,
      containerElement: `<div class="${parentContainerClass}"></div>`,
      containerMethod: `prependTo`,
      root: `div.${parentClass}.component-re-login-status`,
      element: `<div class="${parentClass} component-re-login-status"></div>`,
      method: 'appendTo',
    },
  },
  {
    component: 're-mini-cart',
    target: {
      targetSelector: '.nav-compact-buttons',
      container: `.${parentContainerClass}`,
      containerElement: `<div class="${parentContainerClass}"></div>`,
      containerMethod: `prependTo`,
      root: `div.${parentClass}.component-re-mini-cart`,
      element: `<div class="${parentClass} component-re-mini-cart"></div>`,
      method: 'appendTo',
    },
    responsiveTargets: [
      {
        minWidth: 1120,
        targetSelector: '.page-header-full nav .container > ol',
        root: `li.${parentClass}.component-re-mini-cart`,
        element: `<li class="${parentClass} component-re-mini-cart "></li>`,
        method: 'appendTo'
      }
    ]
  },
  {
    component: 're-loyalty-status',
    componentOptions: {
      component: {
        attributes: {
          showShortMessage: true,
          announceRewards: true
        }
      }
    },
    rendered(instance, item) {
      if (item.resizeObserver) {
        item.resizeObserver.disconnect()
      }
      item.resizeObserver = observeResize(this.$el, () => {
        onLoyaltyStatusResize(instance)
      })
    },
    onResize({instance}) {
      onLoyaltyStatusResize(instance)
    },
    target: {
      targetSelector: '.page-header-compact',
      root: `div.${parentClass}.component-re-loyalty-status`,
      element: `<div class="${parentClass} component-re-loyalty-status mobile-view"></li>`,
      method: 'appendTo'
    },
    responsiveTargets: [
      {
        minWidth: 1120,
        targetSelector: '.page-header-full .header-aux .container nav > ul',
        root: `li.${parentClass}.component-re-loyalty-status`,
        element: `<li class="${parentClass} component-re-loyalty-status"></li>`,
        method: 'appendTo',
      }
    ]
  },
  {
    component: 're-promotion-status',
    target: {
      targetSelector: 'body',
      root: `.${parentClass}.component-re-promotion-status`,
      element: `<div class="${parentClass} component-re-promotion-status"></div>`,
      method: 'appendTo',
    }
  },
]

export const init = () => {
  const promises = miniItems.map(item => {
    return create(item)
  })
  Promise.all(promises).then()
}

export default init
